import React, { useEffect, useState, useRef } from 'react';
import { useQuery } from '@apollo/client';
import { FETCH_COMPLAINT_BY_ID } from '../complaintsById';
import { Spinner } from 'evergreen-ui';
import { formatDate } from '../../../../../widget/util';

function ChatScreen(props) {
  const id = props.id;
  const { loading, error, data } = useQuery(FETCH_COMPLAINT_BY_ID, {
    variables: {
      complaintGetByIdId: id,
    },
  });
  
  const [formattedChats, setFormattedChats] = useState([]);
  const lastChatRef = useRef(null);

  useEffect(() => {
    if (data) {
      const res = data.complaint_getById;
      const chats = res.chat;

      // Assuming each chat has a timestamp field
      const formatted = chats.map(chat => ({
        ...chat,
        formattedDate: formatDate(chat.timestamp),
      }));

      setFormattedChats(formatted);
    }
  }, [data]);

  useEffect(() => {
    // Scroll to the last chat message when the chat screen loads or when new messages are added
    if (lastChatRef.current) {
      lastChatRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [formattedChats]);

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
      <div
        style={{
          width: '100%',
          height: '400px',
          overflow: 'auto',
          border: '1px solid #eee',
          borderRadius: '10px',
        }}
        className="p-16"
      >
        {formattedChats.map((chat, index) => {
          const isLastMessage = index === formattedChats.length - 1;
          return chat.byType === 'facility_manager' ? (
            <MsgSent
              key={index}
              msg={chat.txt}
              date={chat.formattedDate}
              ref={isLastMessage ? lastChatRef : null}
            />
          ) : (
            <MsgReceived
              key={index}
              msg={chat.txt}
              date={chat.formattedDate}
              ref={isLastMessage ? lastChatRef : null}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ChatScreen;

const MsgSent = React.forwardRef((props, ref) => (
  <div ref={ref}>
    <div>
      <small className='right'>Admin</small>
    </div><br/>
    <div style={{
      display: "flex",
      justifyContent: "end"
    }}>
      <div style={{ width: '20%' }}></div>
      <div style={{
        border: "3px solid #eee",
        borderRadius: "10px 0px 10px 10px",
        background: "#eee",
        padding: "8px",
        width: "80%",
        minWidth: "50%",
        maxWidth: "80%",
        marginBottom: "5px",
        marginTop: "5px",
        marginLeft: "20%"
      }} >
        {props.msg}
      </div>
    </div>
  </div>
));

const MsgReceived = React.forwardRef((props, ref) => (
  <div ref={ref}>
    <small>User</small><br/>
    <div className='white-text' style={{
      border: "3px solid #4F46E5",
      borderRadius: "0px 10px 10px 10px",
      background: "#4F46E5",
      padding: "8px",
      minWidth: "50%",
      maxWidth: "80%",
      marginBottom: "5px",
      marginTop: "5px",
    }} >
      {props.msg}
    </div>
  </div>
));
